"use client";

import { useState, type ReactNode } from "react";

export const GLOSSARY = {
  tierce:
    "Intervalle de 3 degrés (Do→Mi). Tierce majeure = 4 demi-tons, mineure = 3 demi-tons.",
  quinte:
    "Intervalle de 5 degrés (Do→Sol). Quinte juste = 7 demi-tons. Donne la stabilité à l'accord.",
  tonique:
    "Note fondamentale qui donne son nom à l'accord et à la tonalité.",
  octave:
    "Intervalle de 8 degrés (12 demi-tons) entre une note et sa répétition aiguë/grave.",
  renversement:
    "Réorganisation des notes d'un accord en plaçant une autre note à la basse.",
  voicing:
    "Façon de répartir les notes d'un accord, hauteur et ordre des notes.",
  degre:
    "Position d'un accord dans une tonalité, noté en chiffres romains : I (tonique), ii (sus-tonique), iii (médiante), IV (sous-dominante), V (dominante), vi (sus-dominante), vii° (sensible). Majuscules = majeur, minuscules = mineur.",
  quarteEtSixte:
    "Cadence où l'accord de tonique apparaît en 2e renversement avant la dominante (I⁶⁴ → V → I). Très utilisée en musique classique.",
  dominante7:
    "Accord de septième mineure construit sur le 5e degré (V) d'une tonalité majeure. Crée une forte tension qui se résout sur la tonique.",
} as const;

export type GlossaryKey = keyof typeof GLOSSARY;

const VIOLET = "#8b5cf6";
const VIOLET_GLOW = "rgba(139, 92, 246, 0.35)";

type Props = {
  termKey: GlossaryKey;
  children: ReactNode;
};

export function Term({ termKey, children }: Props) {
  const [show, setShow] = useState(false);
  const def = GLOSSARY[termKey];

  return (
    <span
      className="relative inline-block"
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      <span
        style={{
          borderBottom: `1px dotted ${VIOLET}`,
          cursor: "help",
          color: "var(--color-violet-text)",
        }}
      >
        {children}
      </span>
      {show && (
        <span
          className="pointer-events-none"
          style={{
            position: "absolute",
            bottom: "100%",
            left: "50%",
            transform: "translateX(-50%) translateY(-6px)",
            width: 220,
            padding: "8px 10px",
            background: "#1a1a22",
            border: `1px solid ${VIOLET_GLOW}`,
            borderRadius: 8,
            fontSize: 11,
            lineHeight: 1.5,
            color: "rgba(255,255,255,0.92)",
            fontWeight: 400,
            letterSpacing: 0,
            zIndex: 100,
            boxShadow: "0 8px 24px rgba(0,0,0,0.5)",
            textAlign: "left",
          }}
        >
          {def}
        </span>
      )}
    </span>
  );
}
